// extracted by mini-css-extract-plugin
export default {"container":"ColorContrast_container__EOi+v"};